import { isArray } from 'lodash-es';

export default (user, roles) => {
  if (isArray(roles)) {
    return user.roles.some((role) => roles.includes(role.name));
  }

  return user.roles.some((role) => role.name === roles);
};
